import { uuid } from '@root/utils/generateUuid'

export const clientId = process.env.NEXT_PUBLIC_CLIENT_ID

export const ICON_BASE_URL = 'https://mtsmoney.mts.ru/tsp/data/tsp_icon/'

export const ICON_TCP = 'https://staticpayment.ssl.mts.ru/prov-icons/'

export const GAMES_URL = 'https://payment.mts.ru/categories/games'

export const NEW_CARD_URL =
  'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/?utm_source=payment&utm_medium=promo&utm_campaign=cashback30&utm_content=cyber'

export const CONTRACT_URL =
  'https://static.mts.ru/uploadmsk/contents/1655/soglashenie_easy_pay.pdf?_ga=1.125490114.915762629.1465198111'

export const CONDITIONS_URL = 'https://static.ssl.mts.ru/mts_rf/images/usloviya-edinogo-dostupa-k-servisam-MTS.html'

export const CASHBACK_URL = 'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/'

export const MAIN_PATH = 'https://payment.mts.ru/cyber'

export const MESSAGE_COMMISSION = 'Ошибка расчета комиссии, попробуйте снова'

export const MESSAGE_NO_MTS_CARD = 'Не карта МТС банка'

export const MESSAGE_PAYMENT_ERROR = 'Ошибка оплаты'

export const MESSAGE = 'Ошибка при получении данных'

export const MESSAGE_INARIUS = 'Ошибка при регистрации телефона'

export const MESSAGE_REVIEW = 'Ошибка при отправке отзыва'

export const MESSAGE_QR = 'Ошибка при генерации QR Code'

export const MESSAGE_ERROR_PROMOCODE = 'Ошибка активации промокода'

export const MESSAGE_QR_DUBLICATE =
  'QR-код был использован ранее. Обновите страницу, чтобы получить новый код для оплаты'

export const MESSAGE_QR_VPN =
  'Похоже, что у вас включен VPN. Отключите его, закройте вкладку с\u00A0нашим сайтом и откройте её снова, затем попробуйте оплатить ещё раз.'

export const STEAM_COURSE = 'Не удалось рассчитать сумму'

export const MESSAGE_QR_STEAM = 'Не можем пополнить данный аккаунт. Проверьте корректность введенных данных'

export const MESSAGE_NO_WORK_SERVICE = 'Сервис временно не работает'

export const MESSAGE_QR_STATUS = 'Ошибка получения статуса оплаты'

export const MESSAGE_QR_STATUS_NOT_FOUND = 'Платеж не найден'

export const ERROR_MESSAGE_CHECK = 'Не удалось скачать чек операции, повторите попытку позже.'

export const CYBER_PAY_URL_RESULT = 'cyber/result/:mdOrder'

export const CYBER_PAY_URL_RESULT_SBP = 'cyber/resultSBP/:qrcId'

export const CARD_MIR =
  'https://www.mtsbank.ru/chastnim-licam/karti/mir-lite-cashback/?utm_source=payment&utm_medium=promo&utm_campaign=cashback30&utm_content=cyber'

export const FULL_TERMS = 'https://staticpayment.ssl.mts.ru/upload/cashback_for_paying_for_foreign_services.pdf'

export const RULES_OF_THE_PROMOTION = 'https://staticpayment.ssl.mts.ru/upload/pravila_akcii.pdf'

export const FULL_LIST_USERS = 'https://staticpayment.ssl.mts.ru/upload/List_of_participants_for_inarius_draws.pdf'

export const FULL_LIST_USERS_NY_ITOGI_500 =
  'https://staticpayment.ssl.mts.ru/upload/pobediteli_garantirovannogo_priza_500rub.pdf'

export const FULL_LIST_USERS_NY_ITOGI_1000 =
  'https://staticpayment.ssl.mts.ru/upload/pobediteli_garantirovannogo_priza_1000rub.pdf'

export const FULL_LIST_USERS_NY_ITOGI =
  'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_rozygrysha_glavnykh_prizov.pdf'
export const FULL_LIST_USERS_VESENNEGO_ROZYGRISHA =
  'https://staticpayment.ssl.mts.ru/upload/spisok_uchastnikov_vesennego_rozygrysha.pdf'

export const INSTRUCTIONS = 'https://www.mtsbank.ru/chastnim-licam/vse-servici/mtsdengi-apk/'

export const PREMIUM = 'https://premium.mts.ru/'

export const APP_STORE =
  'https://apps.apple.com/ru/app/%D0%BC%D0%BE%D0%B9-%D0%BA%D0%BE%D1%88%D0%B5%D0%BB%D0%B5%D0%BA/id6450266264'

export const CYBER_URL = '/cyber'

export const STEAM_URL = '/cyber/steam'

export const MTS_FOG_PLAY = 'https://fogplay.mts.ru/?code=STEAMPAY15&utm_source=mtspayment&utm_medium=promocode'

export const FINAL_TOURNAMENT = 'https://vkvideo.ru/playlist/-112288603_-2/video-112288603_456242487'

export const MTS_TOURNAMENT = 'https://lnk.bio/MTS_Oplata'

export const categoryRequestParams = {
  requestId: uuid(),
  id: null,
  categoryName: 'comeback',
  showHidden: true,
  showFromHiddenCategories: true,
}

export const ewalletReqHeaders = {
  'Client-Id': clientId,
}

export const reqHeaders = {
  'Client-Id': clientId,
  'Content-Type': 'application/json',
}

export const reqHeadersQR = {
  'X-Request-ID': uuid(),
  ...reqHeaders,
}

export const DELAY = 300
